import TalkizyAPI from '@app/services/API/Talkizy';

const TALKIZY_FREE_PLAN = 'free';

const TEACH_TO_TALKIZY_PLAN = {
  PRO: { label: 'Plus', color: 'is-info' },
  EXPERT: { label: 'Max', color: 'is-primary' },
};

export default {
  data() {
    return {
      isLoading: false,
      isLoginLoading: false,
      poll: null,
      talkizyStatus: null,
      hasFetchedStatus: false,
    };
  },
  computed: {
    isConnected() {
      return this.$store.getters['auth/isTalkizyConnected'];
    },
    teachPlan() {
      return this.$store.getters['auth/store']?.plan;
    },
    talkizyPlan() {
      return TEACH_TO_TALKIZY_PLAN[this.teachPlan] || null;
    },
    talkizyStoredPlan() {
      return this.$store.getters['auth/store']?.talkizy_plan ?? null;
    },
    showUpgradeBanner() {
      return this.isConnected && this.talkizyPlan && this.talkizyStoredPlan === TALKIZY_FREE_PLAN;
    },
    ownerConnected() {
      return this.talkizyStatus ? !!this.talkizyStatus.owner_connected : this.isConnected;
    },
    isMember() {
      return this.talkizyStatus
        ? !!this.talkizyStatus.is_member
        : !!this.$store.getters['auth/isTalkizyMember'];
    },
    canJoin() {
      return this.talkizyStatus ? !!this.talkizyStatus.can_join : false;
    },
    isAdminRole() {
      return this.talkizyStatus ? this.talkizyStatus.role === 'ADMIN' : false;
    },
  },
  beforeDestroy() {
    if (this.poll) {
      clearInterval(this.poll);
      this.poll = null;
    }
  },
  methods: {
    async openRegistration() {
      await this.openSSOPopup(() => TalkizyAPI.getSSORegisterUrl(), 'isLoading');
    },

    async openLogin() {
      await this.openSSOPopup(() => TalkizyAPI.getSSOLoginUrl(), 'isLoginLoading');
    },

    async fetchTalkizyStatus() {
      try {
        this.talkizyStatus = await TalkizyAPI.getStatus();
      } catch (e) {
        this.talkizyStatus = null;
      } finally {
        this.hasFetchedStatus = true;
      }
    },

    async openJoin() {
      await this.openSSOPopup(() => TalkizyAPI.getJoinUrl(), 'isLoading');
    },

    async openSSOPopup(urlFn, loadingKey) {
      this[loadingKey] = true;
      const wasConnected = this.isConnected;

      try {
        const { redirect_url } = await urlFn();
        const popup = window.open(redirect_url, 'talkizy-sso', 'width=600,height=700');

        if (!popup) {
          this.$buefy.toast.open({ message: 'Veuillez autoriser les popups pour continuer.', type: 'is-warning' });
          this[loadingKey] = false;
          return;
        }

        this.poll = setInterval(async() => {
          if (popup.closed) {
            clearInterval(this.poll);
            this.poll = null;
            try {
              await this.$store.dispatch('auth/fetch');
              // Le store ne porte que `isTalkizyConnected` : les écrans qui
              // s'appuient sur talkizyStatus (owner_connected, is_member, role)
              // resteraient figés sur l'état d'avant le SSO sans ce refetch.
              await this.fetchTalkizyStatus();
              if (!wasConnected && this.isConnected && this.talkizyPlan) {
                this.$buefy.toast.open({
                  message: `Votre abonnement Teachizy vous permet de bénéficier du forfait Talkizy ${this.talkizyPlan.label} !`,
                  type: 'is-success',
                  duration: 6000,
                });
              }
            } catch (e) {
              this.$buefy.toast.open({ message: 'Une erreur est survenue.', type: 'is-danger' });
            } finally {
              this[loadingKey] = false;
            }
          }
        }, 1000);
      } catch (e) {
        this[loadingKey] = false;
        this.$buefy.toast.open({ message: 'Une erreur est survenue.', type: 'is-danger' });
      }
    },
  },
};
